'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');

const requiredText = "_required-text_1626y_1";
const styles = {
	requiredText: requiredText
};

const LabelRequiredText = ({ children, isDisabled }) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    jsxRuntime.jsx("span", { "aria-hidden": "true", className: styles.requiredText, "data-state": isDisabled ? "disabled" : void 0, "data-zds": true, children })
  );
};

exports.LabelRequiredText = LabelRequiredText;
//# sourceMappingURL=LabelRequiredText.cjs.js.map
